import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo-container">
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="200" height="200" viewBox="0 0 468.000000 452.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,452.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path className='cblue' d="M859 4051 l-39 -39 2 -1446 3 -1446 33 -32 32 -33 1450 0 1450 0 32
33 33 32 0 1451 0 1451 -37 34 -38 34 -1441 0 -1441 0 -39 -39z m2811 -1481
l0 -1330 -1330 0 -1330 0 0 1330 0 1330 1330 0 1330 0 0 -1330z"/>
<path className='cblue' d="M1856 3848 c3 -7 81 -89 174 -183 l169 -170 -120 -121 c-129 -129
-139 -150 -91 -182 22 -14 26 -11 150 111 l127 127 478 -478 477 -477 -592
-592 -593 -593 70 0 70 0 560 560 560 560 162 -162 163 -163 0 65 0 65 -130
130 -130 130 130 130 130 130 0 70 0 70 -165 -165 -165 -165 -477 478 -478
477 173 173 c94 95 172 176 172 180 0 4 -26 7 -57 7 l-58 0 -147 -147 -148
-148 -148 148 -147 147 -62 0 c-46 0 -61 -3 -57 -12z"/>
<path className='cred' d="M1860 2845 c-74 -21 -127 -54 -181 -112 -67 -71 -92 -131 -97 -229
-6 -113 16 -196 94 -354 54 -109 194 -333 262 -419 l19 -23 46 59 c133 173
257 392 308 544 28 83 31 103 27 180 -3 72 -9 97 -36 152 -80 162 -271 249
-442 202z m176 -204 c151 -69 135 -294 -24 -342 -83 -25 -178 16 -219 94 -21
41 -20 124 1 164 18 36 74 85 108 95 43 12 93 8 134 -11z"/>
<path className='cblue' d="M1040 655 l0 -205 25 0 c25 0 25 0 25 95 l0 95 205 0 205 0 0 -95 0
-95 30 0 30 0 -2 203 -3 202 -27 3 -28 3 0 -85 0 -86 -205 0 -205 0 0 85 c0
84 0 85 -25 85 l-25 0 0 -205z"/>
<path className='cblue' d="M2150 710 c0 -201 12 -222 137 -255 73 -19 143 -19 216 0 125 33 137
54 137 255 l0 151 -27 -3 -28 -3 -5 -157 c-5 -142 -7 -159 -25 -172 -31 -24
-84 -36 -161 -36 -79 0 -128 13 -161 43 -21 19 -23 29 -25 171 l-3 151 -27 3
-28 3 0 -151z"/>
<path className='cblue' d="M3240 655 l0 -205 199 0 c110 0 202 4 205 8 16 25 -16 32 -179 34
l-170 3 -3 73 -3 72 166 0 165 0 0 25 0 25 -165 0 -165 0 0 60 0 60 175 0 175
0 0 25 0 25 -200 0 -200 0 0 -205z"/>
</g>
</svg>
    </div>
  );
};

export default Logo;